import { Content } from './Content';

export interface GizmoData {
  id: string;
  title: string;
  direction: [x: number, y: number, z: number];
  size?: string;
  icon: string;
  content: Content;
}

export interface SceneData {
  bg: string;
  initialRotation?: [x: number, y: number, z: number];
  gizmos: GizmoData[];
}

export const loadScene = async (filepath: string): Promise<SceneData> => {
  const response = await fetch(filepath);
  const body: SceneData = await response.json();
  return body;
};
